
import "./ToggleSwitchCore.st.css.js";

import { classesRuntime, statesRuntime } from "./../../stylable-esm-runtime.js";



var _namespace_ = "wds_1_223_0_ToggleSwitchCoreLayout";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_223_0_ToggleSwitchCoreLayout__root"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {"rootWidth":"var(--wds-toggle-switch-width-large, 46px)","rootHeight":"var(--wds-toggle-switch-knob-size-large, 22px)","knobWidth":"var(--wds-toggle-switch-knob-size-large, calc(var(--wds-toggle-switch-knob-size-large, 22px) / 1.2))","knobHeight":"var(--wds-toggle-switch-knob-size-large, calc(var(--wds-toggle-switch-knob-size-large, 22px) / 1.2))","trackWidth":"var(--wds-toggle-switch-width-large, 46px)","trackHeight":"var(--wds-toggle-switch-knob-size-large, 22px)","knobMovementRange":"calc(calc(var(--wds-toggle-switch-width-large, 46px) / 2) - calc(var(--wds-toggle-switch-knob-size-large, calc(var(--wds-toggle-switch-knob-size-large, 22px) / 1.2)) / 2))"}; 
export var vars = {"wds-border-radius-full":"--wds-border-radius-full","wds-toggle-switch-knob-size-large":"--wds-toggle-switch-knob-size-large","wds-toggle-switch-padding":"--wds-toggle-switch-padding","wds-toggle-switch-width-large":"--wds-toggle-switch-width-large","wds-toggle-switch-knob-text-height":"--wds-toggle-switch-knob-text-height"}; 




